import { render, staticRenderFns } from "./music.vue?vue&type=template&id=a36c8488&scoped=true&"
import script from "./music.vue?vue&type=script&lang=js&"
export * from "./music.vue?vue&type=script&lang=js&"
import style0 from "./music.vue?vue&type=style&index=0&id=a36c8488&lang=scss&scoped=true&"
import style1 from "./music.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36c8488",
  null
  
)

export default component.exports